"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IdeaRoomCode = void 0;
var react_1 = __importStar(require("react"));
var react_2 = __importDefault(require("@monaco-editor/react"));
var monaco_editor_1 = require("monaco-editor");
var re_resizable_1 = require("re-resizable");
var Expression_1 = require("../languages/Expression");
var theme_1 = require("../types/theme");
var convertSizeToNumber_1 = require("../utils/convertSizeToNumber");
var themeUtils_1 = require("../utils/themeUtils");
var Language_1 = require("../constants/Language");
var languageUtils_1 = require("../utils/languageUtils");
var Html_1 = require("../languages/Html");
var ConditionalWrapper = function (_a) {
    var condition = _a.condition, wrapper = _a.wrapper, children = _a.children;
    return condition ? wrapper(children) : children;
};
function ResizableWrapper(_a) {
    var width = _a.width, height = _a.height, children = _a.children, onResize = _a.onResize;
    var _b = (0, react_1.useState)((0, convertSizeToNumber_1.convertSizeToNumber)(height)), resizeHeight = _b[0], setHeight = _b[1];
    var _c = (0, react_1.useState)((0, convertSizeToNumber_1.convertSizeToNumber)(width)), resizeWidth = _c[0], setWidth = _c[1];
    var childrenWithProps = react_1.Children.map(children, function (child) {
        // Checking isValidElement is the safe way and avoids a typescript error too.
        if ((0, react_1.isValidElement)(child)) {
            return (0, react_1.cloneElement)(child, { width: '100%', height: '100%' });
        }
        return child;
    });
    return (react_1.default.createElement(re_resizable_1.Resizable, { defaultSize: {
            width: resizeWidth,
            height: resizeHeight,
        }, onResize: function (e, direction, ref, d) {
            setWidth(resizeWidth + d.width);
            setHeight(resizeHeight + d.height);
        }, onResizeStop: function (e, direction, ref) {
            var _a = ref.style, newHeight = _a.height, newWidth = _a.width;
            if (onResize)
                onResize({ width: newWidth, height: newHeight });
        } }, childrenWithProps));
}
exports.IdeaRoomCode = (0, react_1.forwardRef)(function (_a, ref) {
    var className = _a.className, _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.height, height = _c === void 0 ? '100%' : _c, language = _a.language, defaultLanguage = _a.defaultLanguage, value = _a.value, defaultValue = _a.defaultValue, theme = _a.theme, resizable = _a.resizable, options = _a.options, beforeMount = _a.beforeMount, onChange = _a.onChange, onMount = _a.onMount, onValidate = _a.onValidate, onResize = _a.onResize, customFormatters = _a.customFormatters;
    var handleEditorBeforeMount = function (monaco) {
        if (typeof beforeMount === 'function') {
            beforeMount(monaco);
        }
        if (language && language === Language_1.Language.Expression) {
            (0, Expression_1.initializeExpressionLanguage)(monaco);
        }
        if (language && language === Language_1.Language.Html) {
            (0, Html_1.initializeHTMLLanguage)(monaco);
        }
        (0, languageUtils_1.addLanguageFormatters)(monaco, language, customFormatters);
    };
    var handleEditorOnMount = function (editor, monaco) {
        var _a, _b;
        if (typeof onMount === 'function') {
            onMount(editor, monaco);
        }
        var monacoEditor = monaco.editor;
        if (ref !== undefined && ref !== null) {
            // eslint-disable-next-line no-param-reassign
            ref.current = {
                editor: editor,
                monaco: monaco,
            };
        }
        editor.focus();
        // Set the cursor so it's after any typing that opened the editor
        var lastLine = ((_a = editor.getModel()) === null || _a === void 0 ? void 0 : _a.getLineCount()) || 0;
        var lastColumn = ((_b = editor.getModel()) === null || _b === void 0 ? void 0 : _b.getLineMaxColumn(lastLine)) || 0;
        editor.setSelection(new monaco_editor_1.Selection(lastLine, lastColumn, lastLine, lastColumn));
        if (!theme || !Object.values(theme_1.CustomTheme).includes(theme))
            return;
        editor.updateOptions({
            wordBasedSuggestions: false,
        });
        var themeData = (0, themeUtils_1.getThemeData)(theme);
        if (!themeData)
            return;
        monacoEditor.defineTheme(theme, themeData);
        monacoEditor.setTheme(theme);
    };
    return (react_1.default.createElement(ConditionalWrapper, { condition: resizable, wrapper: function (children) { return ResizableWrapper({ width: width, height: height, children: children, onResize: onResize }); } },
        react_1.default.createElement(react_2.default, { key: "ir-code-".concat(theme), className: className, width: width, height: height, language: language === Language_1.Language.Expression ? Language_1.Language.JavaScript : language, defaultLanguage: defaultLanguage === Language_1.Language.Expression ? Language_1.Language.JavaScript : defaultLanguage, value: value, defaultValue: defaultValue, theme: theme, options: options, onChange: onChange, onValidate: onValidate, beforeMount: handleEditorBeforeMount, onMount: handleEditorOnMount })));
});
